/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FieldListEditWrapper } from "cms/fields/field-lists/field-list-wrapper";
import PhoneNumberFieldItemEdit from "./edit-item";

const PhoneNumberFieldEdit = () => {
    
    return (
        <FieldListEditWrapper>
            <PhoneNumberFieldItemEdit />
        </FieldListEditWrapper>
    );
};
PhoneNumberFieldEdit.displayName = "PhoneNumberFieldEdit";
export { PhoneNumberFieldEdit };
